import { render } from "./ListaPedidosView.vue?vue&type=template&id=607553db&scoped=true"
import script from "./ListaPedidosView.vue?vue&type=script&lang=js"
export * from "./ListaPedidosView.vue?vue&type=script&lang=js"

import "./ListaPedidosView.vue?vue&type=style&index=0&id=607553db&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607553db"]])

export default __exports__